import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function VeridianStart() {
  const navigate = useNavigate();
  const [name, setName] = useState('');

  return (
    <div className="min-h-screen bg-black font-mono flex items-center justify-center p-6 relative overflow-hidden">
      
      {/* Background Grid */}
      <div className="absolute inset-0 opacity-20" 
           style={{ backgroundImage: 'linear-gradient(#06b6d4 1px, transparent 1px), linear-gradient(90deg, #06b6d4 1px, transparent 1px)', backgroundSize: '40px 40px' }}>
      </div>

      <div className="relative z-10 max-w-2xl w-full border border-cyan-500 bg-slate-900/90 p-10 shadow-[0_0_30px_rgba(6,182,212,0.3)]">
        
        <h1 className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600 mb-2">
          PROJECT VERIDIAN
        </h1>
        <p className="text-cyan-700 text-sm tracking-[0.3em] mb-8">REALITY RECONSTRUCTION ENGINE v1.0</p>

        <div className="space-y-6 text-gray-300 leading-relaxed mb-8 border-l-2 border-cyan-800 pl-4">
          <p>
            You originate from a High-Continuum Society. Your logic, ethics, and language are your tools.
          </p>
          <p>
            This world has degraded. The locals speak in broken structures, thinking in broken loops.
            Infrastructure fails because they cannot conjugate "Maintenance." 
            Justice fails because they cannot sequence "Truth."
          </p>
          <p className="text-white font-bold">
            Will you integrate and decay? Or will you overwrite their reality?
          </p>
        </div>

        <div className="flex gap-4">
            <input 
                type="text" 
                placeholder="ENTER DESIGNATION (NAME)" 
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="flex-grow bg-black border border-cyan-700 p-4 text-cyan-400 focus:border-cyan-400 outline-none"
            />
            <button 
                onClick={() => navigate('/veridian-engine')}
                className="bg-cyan-600 hover:bg-cyan-500 text-black font-bold px-8 py-4 transition-all hover:shadow-[0_0_20px_#06b6d4]"
            >
                INITIALIZE
            </button>
        </div>

      </div>
    </div>
  );
}